


































import { Component, Vue } from 'vue-property-decorator';
import {GeneralService} from '../services/general-service';
import ProgramLevel from '../components/ProgramLevel.vue';
import config from '../services/api-config';
import router from '../router';
import AuthService from '../services/auth-service';

@Component({
  components: {
      'program-level': ProgramLevel
  },
})

export default class LongShortType extends Vue {
    private service = new GeneralService();
    public entities = [
        {fullName: 'All Questions'}, {fullName: 'Pastpaper Questions'}
    ];
    private boards: any = [];
    private activated: boolean = false;
    private boardSelected = false;
    private level_id = JSON.parse(localStorage[config.programSelect] || null);
    private auth = new AuthService();
    public valuename: any = {};
    public storedInfo: any = [];
    public studentData: any = [];

    private selectModule(name) {
        if (name == 'All Questions'){
            this.$router.push('/mcqsubject?type=' + this.$route.query.type);
        } else if (name == 'Pastpaper Questions'){
            this.$router.push('/mcqsubject?type=' + this.$route.query.type + '&past=true');
        }  
        }

    mounted() {

        if (this.level_id == '' || this.level_id == undefined || this.level_id == 'null' || this.level_id.user !== this.auth.session.userId) {
            router.push("select");
        }

        let username = this.auth.session.userName.split("@")[0];
        this.service.getInfoEMS(username).then((result) => {
            if (result && result.data && result.data.length > 0) {
                this.studentData = result.data;
                this.storedInfo = localStorage.getItem(config.studentPartInfo);
                let storedArr = typeof this.storedInfo === 'string' ? JSON.parse(this.storedInfo) : this.storedInfo;
                let currentPart = storedArr.find(p => p.fullName === this.level_id.part);
                this.valuename = currentPart ? this.studentData.find(e => e.Class === currentPart.fullName) : {};
            }
        }).catch((err) => {
            console.error('Error fetching student info:', err);
        });
    }
}
